import { capitalize, displayMembershipCode } from "../../../assets/helpers/funciones";


export const MultipleRenewalsTable = ({ table }) => {
    const { header, data, clientNumber } = table;

    if (data.length === 0) {
        return null
    }

    const sumTotal = (data) => {
        let total = 0

        for (let i = 0; i < data.length; i++) {
            total = total + data[i]?.newMem?.priceInfo?.finalPrice
        }
        return total
    }

    return (
        <>
            <table style={{ marginBottom: "24px" }} className="table payments-table">
                <tr>
                    {header?.map((h, i) => {
                        return (
                            <th
                                key={h?.name + i}
                                style={{ display: h?.hide ? 'none' : '' }}
                            >
                                {h?.name}
                            </th>
                        )
                    })}
                </tr>

                {data?.map((d, i) => (
                    <tr style={{ backgroundColor: i === clientNumber ? "#f27730" : "" }} key={i}>
                        <td >
                            <p style={{ margin: "0px" }}> <b style={{ fontSize: "14px", }}>Membresia {i + 1}</b><br />
                                <b>Clase:</b> {capitalize(d?.newMem?.vehicleData?.className)}<br />
                                <b>Plan:</b>{' '}
                                {capitalize(
                                  displayMembershipCode(d?.newMem?.code?.code)
                                )}
                                <br />
                                <b>Año:</b> {d?.newMem?.vehicleData?.year}<br />
                                <b>RCV:</b> {capitalize(d?.newMem?.rcv)} <br /><br />
                                <b>Monto: {d?.newMem?.priceInfo?.finalPrice}$ </b>
                            </p>
                        </td>
                        <td>
                            <p style={{ margin: "0px" }}>
                                <b style={{ fontSize: "14px", }}>
                                    {d?.newMem?.customer?.firstName + " " + d?.newMem?.customer?.lastName}</b><br />
                                {d?.newMem?.customer?.identificationType + "-" + d?.newMem?.customer?.identification}<br />
                                {d?.newMem?.customer?.phonePrefix + "-" + d?.newMem?.customer?.phoneNumber}<br />
                                {d?.newMem?.customer?.email} <br />
                            </p>
                        </td>
                        <td>
                            <p style={{ margin: "0px" }}> <b style={{ marginBottom: "12px", fontSize: "14px", }}>{d?.newMem?.vehicleData?.plate}</b><br />
                                {capitalize(d?.newMem?.vehicleData?.brandName) + " " + capitalize(d?.newMem?.vehicleData?.modelName)}<br />
                            </p>
                        </td>
                    </tr >
                ))}
                <tr>
                    <td><b style={{ fontSize: "18px" }}>Total: {sumTotal(data)}$</b></td>
                    <td></td>
                    <td></td>
                </tr>
            </table >
        </>
    )
};
